import {
  createPaymentAcceptanceConfiguration as publicCreatePaymentAcceptanceConfiguration,
  getPaymentAcceptanceConfiguration as publicGetPaymentAcceptanceConfiguration,
  updatePaymentAcceptanceConfiguration as publicUpdatePaymentAcceptanceConfiguration,
  addPaymentAcceptanceConfigurationRules as publicAddPaymentAcceptanceConfigurationRules,
  removePaymentAcceptanceConfigurationRules as publicRemovePaymentAcceptanceConfigurationRules,
  modifyPaymentAcceptanceConfigurationRules as publicModifyPaymentAcceptanceConfigurationRules,
  deletePaymentAcceptanceConfiguration as publicDeletePaymentAcceptanceConfiguration,
  queryPaymentAcceptanceConfigurations as publicQueryPaymentAcceptanceConfigurations,
  typedQueryPaymentAcceptanceConfigurations as publicTypedQueryPaymentAcceptanceConfigurations,
  bulkUpdatePaymentAcceptanceConfigurationTags as publicBulkUpdatePaymentAcceptanceConfigurationTags,
  bulkUpdatePaymentAcceptanceConfigurationTagsByFilter as publicBulkUpdatePaymentAcceptanceConfigurationTagsByFilter,
} from './payments-payment-acceptance-configurations-v1-payment-acceptance-configuration-payment-acceptance-configurations.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  PaymentAcceptanceConfigurationQuery,
  PaymentAcceptanceConfigurationsQueryBuilder,
  typedQueryPaymentAcceptanceConfigurations as universalTypedQueryPaymentAcceptanceConfigurations,
} from './payments-payment-acceptance-configurations-v1-payment-acceptance-configuration-payment-acceptance-configurations.universal.js';

function customQueryPaymentAcceptanceConfigurations(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () =>
      publicQueryPaymentAcceptanceConfigurations(httpClient)(),
    typedQueryFunction: (query: PaymentAcceptanceConfigurationQuery) =>
      publicTypedQueryPaymentAcceptanceConfigurations(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): PaymentAcceptanceConfigurationsQueryBuilder;
  function overloadedQuery(
    query: PaymentAcceptanceConfigurationQuery
  ): ReturnType<typeof universalTypedQueryPaymentAcceptanceConfigurations>;
  function overloadedQuery(query?: PaymentAcceptanceConfigurationQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

/** @internal */
export const createPaymentAcceptanceConfiguration: MaybeContext<
  BuildRESTFunction<typeof publicCreatePaymentAcceptanceConfiguration> &
    typeof publicCreatePaymentAcceptanceConfiguration
> = /*#__PURE__*/ createRESTModule(publicCreatePaymentAcceptanceConfiguration);
/** @internal */
export const getPaymentAcceptanceConfiguration: MaybeContext<
  BuildRESTFunction<typeof publicGetPaymentAcceptanceConfiguration> &
    typeof publicGetPaymentAcceptanceConfiguration
> = /*#__PURE__*/ createRESTModule(publicGetPaymentAcceptanceConfiguration);
/** @internal */
export const updatePaymentAcceptanceConfiguration: MaybeContext<
  BuildRESTFunction<typeof publicUpdatePaymentAcceptanceConfiguration> &
    typeof publicUpdatePaymentAcceptanceConfiguration
> = /*#__PURE__*/ createRESTModule(publicUpdatePaymentAcceptanceConfiguration);
/** @internal */
export const addPaymentAcceptanceConfigurationRules: MaybeContext<
  BuildRESTFunction<typeof publicAddPaymentAcceptanceConfigurationRules> &
    typeof publicAddPaymentAcceptanceConfigurationRules
> = /*#__PURE__*/ createRESTModule(
  publicAddPaymentAcceptanceConfigurationRules
);
/** @internal */
export const removePaymentAcceptanceConfigurationRules: MaybeContext<
  BuildRESTFunction<typeof publicRemovePaymentAcceptanceConfigurationRules> &
    typeof publicRemovePaymentAcceptanceConfigurationRules
> = /*#__PURE__*/ createRESTModule(
  publicRemovePaymentAcceptanceConfigurationRules
);
/** @internal */
export const modifyPaymentAcceptanceConfigurationRules: MaybeContext<
  BuildRESTFunction<typeof publicModifyPaymentAcceptanceConfigurationRules> &
    typeof publicModifyPaymentAcceptanceConfigurationRules
> = /*#__PURE__*/ createRESTModule(
  publicModifyPaymentAcceptanceConfigurationRules
);
/** @internal */
export const deletePaymentAcceptanceConfiguration: MaybeContext<
  BuildRESTFunction<typeof publicDeletePaymentAcceptanceConfiguration> &
    typeof publicDeletePaymentAcceptanceConfiguration
> = /*#__PURE__*/ createRESTModule(publicDeletePaymentAcceptanceConfiguration);
/** @internal */
export const bulkUpdatePaymentAcceptanceConfigurationTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdatePaymentAcceptanceConfigurationTags> &
    typeof publicBulkUpdatePaymentAcceptanceConfigurationTags
> = /*#__PURE__*/ createRESTModule(
  publicBulkUpdatePaymentAcceptanceConfigurationTags
);
/** @internal */
export const bulkUpdatePaymentAcceptanceConfigurationTagsByFilter: MaybeContext<
  BuildRESTFunction<
    typeof publicBulkUpdatePaymentAcceptanceConfigurationTagsByFilter
  > &
    typeof publicBulkUpdatePaymentAcceptanceConfigurationTagsByFilter
> = /*#__PURE__*/ createRESTModule(
  publicBulkUpdatePaymentAcceptanceConfigurationTagsByFilter
);
export const queryPaymentAcceptanceConfigurations: MaybeContext<
  BuildRESTFunction<typeof customQueryPaymentAcceptanceConfigurations> &
    typeof customQueryPaymentAcceptanceConfigurations
> = /*#__PURE__*/ createRESTModule(customQueryPaymentAcceptanceConfigurations);

export {
  SortOrder,
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
  WebhookIdentityType,
} from './payments-payment-acceptance-configurations-v1-payment-acceptance-configuration-payment-acceptance-configurations.universal.js';
export {
  PaymentAcceptanceConfiguration,
  PaymentAcceptanceRule,
  PaymentBrands,
  Countries,
  Currencies,
  Restrictions,
  RestrictionsPaymentBrandsOneOf,
  RestrictionsCountriesOneOf,
  RestrictionsCurrenciesOneOf,
  ExtendedFields,
  Tags,
  TagList,
  CreatePaymentAcceptanceConfigurationRequest,
  CreatePaymentAcceptanceConfigurationResponse,
  GetPaymentAcceptanceConfigurationRequest,
  GetPaymentAcceptanceConfigurationResponse,
  UpdatePaymentAcceptanceConfigurationRequest,
  UpdatePaymentAcceptanceConfigurationResponse,
  AddPaymentAcceptanceConfigurationRulesRequest,
  AddPaymentAcceptanceConfigurationRulesResponse,
  RemovePaymentAcceptanceConfigurationRulesRequest,
  RemovePaymentAcceptanceConfigurationRulesResponse,
  ModifyPaymentAcceptanceConfigurationRulesRequest,
  MaskedRules,
  ModifyPaymentAcceptanceConfigurationRulesResponse,
  DeletePaymentAcceptanceConfigurationRequest,
  DeletePaymentAcceptanceConfigurationResponse,
  QueryPaymentAcceptanceConfigurationsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryPaymentAcceptanceConfigurationsResponse,
  CursorPagingMetadata,
  Cursors,
  BulkUpdatePaymentAcceptanceConfigurationTagsRequest,
  BulkUpdatePaymentAcceptanceConfigurationTagsResponse,
  ItemMetadata,
  ApplicationError,
  BulkUpdatePaymentAcceptanceConfigurationTagsResult,
  BulkActionMetadata,
  BulkUpdatePaymentAcceptanceConfigurationTagsByFilterRequest,
  BulkUpdatePaymentAcceptanceConfigurationTagsByFilterResponse,
  Empty,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  UpdatePaymentAcceptanceConfiguration,
  AddPaymentAcceptanceConfigurationRulesOptions,
  RemovePaymentAcceptanceConfigurationRulesOptions,
  ModifyPaymentAcceptanceConfigurationRulesOptions,
  PaymentAcceptanceConfigurationsQueryResult,
  PaymentAcceptanceConfigurationsQueryBuilder,
  PaymentAcceptanceConfigurationQuerySpec,
  BulkUpdatePaymentAcceptanceConfigurationTagsOptions,
  BulkUpdatePaymentAcceptanceConfigurationTagsByFilterOptions,
} from './payments-payment-acceptance-configurations-v1-payment-acceptance-configuration-payment-acceptance-configurations.universal.js';
export { utils } from './payments-payment-acceptance-configurations-v1-payment-acceptance-configuration-payment-acceptance-configurations.universal.js';
export {
  SortOrderWithLiterals,
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  PaymentAcceptanceConfigurationQuery,
} from './payments-payment-acceptance-configurations-v1-payment-acceptance-configuration-payment-acceptance-configurations.universal.js';
